import { toPairs } from 'lodash';
import { GrantStatus } from 'common/schema/Grant';
import { GrantStatusTag } from './GrantStatusTag';

export const GrantStatusOptions = toPairs(GrantStatus).map(([key, value]) => ({
  label: GrantStatusTag({ status: value }),
  value: value
}));
